import { type AccountConfig } from '../../../../models/Account'

// Strips crossClientQueryAiPhaseAllowedUserIds entries that aren't on the current user list.
// account.config is spread wholesale into full-config PATCHes from several widgets on this page
// (AccountSettings, AccountRegionalSettings, BusinessAddressSettings), so any of their saves would
// otherwise carry a grant to a removed user straight back through, since ClientQueryUserAccessTable
// only prunes its own local form on its own save. validUserIds is null while the fresh user list is
// still loading, so a save mid-fetch can't wipe every id against an empty/stale set.
export const sanitizeAccountConfig = (config: AccountConfig, validUserIds: Set<string> | null): AccountConfig => {
  if (!validUserIds || !config.crossClientQueryAiPhaseAllowedUserIds) {
    return config
  }
  return {
    ...config,
    crossClientQueryAiPhaseAllowedUserIds: config.crossClientQueryAiPhaseAllowedUserIds.filter((userId) => validUserIds.has(userId)),
  }
}
